import { useState } from "react";
import { ChartLineUp, CalendarBlank, BowlFood, Brain, PersonSimpleRun, GearSix, Trophy, CaretDown, CaretRight, ListChecks, Barbell, Target } from "@phosphor-icons/react";

const WORKOUT_CATEGORIES = [
  { id: "all", label: "All Workouts" },
  { id: "Strength", label: "Strength" },
  { id: "Mass", label: "Mass" },
  { id: "Cardio", label: "Cardio" },
];

const navItems = [
  { id: "dashboard", label: "Summary", icon: ChartLineUp },
  { id: "calendar", label: "Schedule", icon: CalendarBlank },
  { id: "body", label: "Body", icon: PersonSimpleRun },
  { id: "macros", label: "Calories", icon: BowlFood },
  { id: "ai", label: "Coach", icon: Brain },
  { id: "prs", label: "PRs", icon: Trophy },
  { id: "settings", label: "Settings", icon: GearSix },
];

export default function Sidebar({ activeTab, setActiveTab, onCategoryChange }) {
  const [workoutsOpen, setWorkoutsOpen] = useState(false);

  const isWorkoutsActive = activeTab === "templates" || activeTab === "logger";

  const handleWorkoutCategory = (catId) => {
    onCategoryChange?.(catId === "all" ? null : catId);
    setActiveTab("templates");
  };

  return (
    <aside className="hidden md:flex flex-col w-56 bg-[#161616] border-r border-[#27272A] h-screen" data-testid="sidebar">
      <div className="px-5 py-6 border-b border-[#27272A]">
        <h1
          className="text-xl font-black tracking-tighter uppercase text-white"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          data-testid="app-title"
        >
          <span className="text-[#E05A1D]">UP</span>TOP
        </h1>
      </div>
      <nav className="flex-1 py-4 overflow-y-auto" data-testid="sidebar-nav">
        {navItems.map((item) => {
          if (item.id === "calendar") {
            return (
              <div key="workouts-group">
                <button
                  onClick={() => {
                    setWorkoutsOpen(!workoutsOpen);
                    if (!workoutsOpen) {
                      onCategoryChange?.(null);
                      setActiveTab("templates");
                    }
                  }}
                  className={`sidebar-nav-item w-full text-left flex items-center justify-between ${isWorkoutsActive ? "active" : ""}`}
                  data-testid="nav-workouts"
                >
                  <div className="flex items-center gap-3">
                    <ListChecks size={20} weight={isWorkoutsActive ? "fill" : "regular"} />
                    <span>Workouts</span>
                  </div>
                  {workoutsOpen ? <CaretDown size={14} /> : <CaretRight size={14} />}
                </button>

                {workoutsOpen && (
                  <div className="ml-4 border-l border-[#27272A]" data-testid="workouts-submenu">
                    <button
                      onClick={() => setActiveTab("logger")}
                      className={`w-full text-left px-4 py-2 text-xs font-semibold uppercase tracking-wider flex items-center gap-2 transition-colors ${
                        activeTab === "logger" ? "text-[#E05A1D]" : "text-[#71717A] hover:text-white hover:bg-[#1C1C1C]"
                      }`}
                      data-testid="nav-logger"
                    >
                      <Barbell size={12} weight="bold" /> Log Workout
                    </button>
                    {WORKOUT_CATEGORIES.map((cat) => (
                      <button
                        key={cat.id}
                        onClick={() => handleWorkoutCategory(cat.id)}
                        className="w-full text-left px-4 py-2 text-xs font-semibold uppercase tracking-wider text-[#71717A] hover:text-white hover:bg-[#1C1C1C] transition-colors"
                        data-testid={`nav-workout-${cat.id}`}
                      >
                        {cat.label}
                      </button>
                    ))}
                  </div>
                )}

                <button
                  onClick={() => setActiveTab("plans")}
                  className={`sidebar-nav-item w-full text-left ${activeTab === "plans" ? "active" : ""}`}
                  data-testid="nav-plans"
                >
                  <Target size={20} weight={activeTab === "plans" ? "fill" : "regular"} />
                  <span>Plans</span>
                </button>

                <button
                  onClick={() => setActiveTab(item.id)}
                  className={`sidebar-nav-item w-full text-left ${activeTab === item.id ? "active" : ""}`}
                  data-testid={`nav-${item.id}`}
                >
                  <item.icon size={20} weight={activeTab === item.id ? "fill" : "regular"} />
                  <span>{item.label}</span>
                </button>
              </div>
            );
          }

          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`sidebar-nav-item w-full text-left ${activeTab === item.id ? "active" : ""}`}
              data-testid={`nav-${item.id}`}
            >
              <item.icon size={20} weight={activeTab === item.id ? "fill" : "regular"} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="px-5 py-4 border-t border-[#27272A]">
        <p className="text-xs text-[#71717A] uppercase tracking-wider">v1.0</p>
      </div>
    </aside>
  );
}
